import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  Languages,
  CreditCard,
  Settings,
  FileText,
  BarChart3,
  Workflow
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

const Sidebar = () => {
  const { t } = useTranslation()
  const location = useLocation()
  
  const navigation = [
    { name: t('navigation.dashboard'), href: '/dashboard', icon: LayoutDashboard },
    { name: t('navigation.translation'), href: '/translate', icon: Languages },
    { name: t('navigation.tms_integration'), href: '/tms-integration', icon: Workflow },
    { name: t('navigation.usage'), href: '/usage', icon: BarChart3 },
    { name: t('navigation.payment'), href: '/payment', icon: CreditCard },
    { name: t('navigation.settings'), href: '/settings', icon: Settings },
    { name: t('navigation.documentation'), href: '/docs', icon: FileText },
  ]

  return (
    <div className="fixed inset-y-0 left-0 w-64 bg-white dark:bg-gray-800 shadow-sm border-r border-gray-200 dark:border-gray-700 pt-16">
      <div className="flex flex-col h-full">
        <nav className="flex-1 px-4 py-6 space-y-2">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href
            return (
              <Link
                key={item.name}
                to={item.href}
                className={clsx(
                  'flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary-50 text-primary-700 dark:bg-primary-900/50 dark:text-primary-300'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'
                )}
              >
                <item.icon className="w-5 h-5" />
                <span>{item.name}</span>
              </Link>
            )
          })}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            <p>{t('footer.copyright')}</p>
            <p>{t('footer.version')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sidebar